<template>
    <section>
        <compWrapper
            :title="
                $t('global.common.base_information', {
                    defaultValue: '基本信息',
                })
            "
            theme="primary"
        >
            <compFormEdit
                v-if="type !== 'query'"
                class="margin-layout width-50per"
                ref="formbase"
                :labelWidth="140"
                :formdata="getBase"
                v-model="formData"
                placeholder="--"
                :col="1"
            ></compFormEdit>
            <compFormQuery
                v-else
                class="margin-layout"
                :formdata="getBase"
                :value="formData"
                :labelWidth="140"
                placeholder="--"
                :col="1"
            ></compFormQuery>
            <vButtonGroup slot="footer" v-if="!querytype">
                <vButton theme="primary" @click="save">{{
                    $t("global.common.save", { defaultValue: "保存" })
                }}</vButton>
                <vButton @click="goback">{{
                    $t("global.common.return", { defaultValue: "返回" })
                }}</vButton>
            </vButtonGroup>
        </compWrapper>
        <compWrapper
            :title="
                $t('global.common.operate_history', {
                    defaultValue: '操作历史',
                })
            "
            theme="gray"
            v-if="type === 'query'"
        >
            <compLog
                class="margin-layout"
                :data="logList"
                :columns="logcolumn"
            ></compLog>
        </compWrapper>
        <vLoading size="large" transfer :loading="loading"></vLoading>
    </section>
</template>

<script>
import { mapGetters } from "vuex";
import {
    HttpQueryAccountOne,
    HttpCreateAccountOne,
    HttpSaveAccountOne,
} from "@/service/basicdata";
export default {
    props: ["activeid", "querytype"],
    data() {
        return {
            loading: false,
            type: this.querytype || this.$route.params.type,
            id: this.activeid || this.$route.query.id,
            formData: {
            },
            // workOrderItems: [],
            logList: [], //log,
            modalProps: {
                show: false,
            },
        };
    },
    created() {
        this.getDetail();
    },
    computed: {
        ...mapGetters("dictionary", [
            "getCarrierAllList",
            "getBillcusWareList",
        ]),

        getBase() {
            let formData = [
                {
                    label: this.$t("global.common.warehouse", {
                        defaultValue: "仓库",
                    }),
                    key: "warehouseId",
                    tag: "vSelect",
                    options: this.getBillcusWareList,
                    query: this.type != "add",
                    props: {
                        filterable: true,
                    },
                },
                {
                    label: this.$t("fbb.expresspackage.service_code", {
                        defaultValue: "承运商",
                    }),
                    key: "carrierId",
                    tag: "vSelect",
                    options: this.getCarrierAllList.map((item) => {
                        return {
                            value: item.attach.id,
                            label: item.label,
                        };
                    }),
                    query: this.type != "add",
                    props: {
                        filterable: true,
                    },
                },
                {
                    label: this.$t('fbb.carrieraccount.account_type', { defaultValue: "对接类型" }),
                    key: "accountType",
                    tag: "vSelect",
                    options: [
                        {
                            label: "post",
                            value: 0,
                        },
                        {
                            label: "label",
                            value: 1,
                        },
                    ],
                },
            ];
            let childData = [];
            // accountType = 1 label
            if (this.formData.accountType == 1) {
                childData = [
                    {
                        label: this.$t('fbb.carrieraccount.channel_login_account', { defaultValue: '平台单登录账户' }),
                        key: 'channelLabelAccount',
                        required: false
                    },
                    {
                        label: this.$t('fbb.carrieraccount.channel_label_password', { defaultValue: '平台单登录密码' }),
                        key: 'channelLabelPassword',
                        required: false
                    },
                    {
                        label: this.$t('fbb.carrieraccount.channel_shipper_code', { defaultValue: '平台单shipper Code' }),
                        key: 'channelLabelShipperCode',
                        required: false
                    },
                    {
                        label: this.$t('fbb.carrieraccount.label_account', { defaultValue: '非平台单登录账户' }),
                        key: 'labelAccount',
                        required: false
                    },
                    {
                        label: this.$t('fbb.carrieraccount.label_password', { defaultValue: '非平台单登录密码' }),
                        key: 'labelPassword',
                        required: false
                    },
                    {
                        label: this.$t('fbb.carrieraccount.label_shipper_code', { defaultValue: '非平台单shipper Code' }),
                        key: 'labelShipperCode',
                        required: false
                    }
                ];
            }
            // accountType = 0 post
            else {
                childData = [
                    {
                        label: this.$t("fbb.carrieraccount.shipping_account", {
                            defaultValue: "Shipping账户",
                        }),
                        key: "carrierAccount",
                    },
                    // {
                    //     label: this.$t("fbb.carrieraccount.billing_account", {
                    //         defaultValue: "Billing账户",
                    //     }),
                    //     key: "billingAccount",
                    // },
                ];
            }

            childData.forEach((item) => {
                formData.push(item);
            });
            return formData;
        },
        logcolumn() {
            return [
                {
                    title: this.$t("global.log.operator", {
                        defaultValue: "操作人",
                    }),
                    key: "createdName",
                },
                {
                    title: this.$t("global.log.action", {
                        defaultValue: "操作类型",
                    }),
                    key: "operateType",
                    render: (h, { row }) => {
                        return this.operateType == 1
                            ? this.$t("global.common.create", {
                                  defaultValue: "创建",
                              })
                            : this.$t("fbb.reserveinbound.update", {
                                  defaultValue: "更新",
                              });
                    },
                },
                {
                    title: this.$t("global.common.before_value", {
                        defaultValue: "更改前值",
                    }),
                    key: "beforeValue",
                },
                {
                    title: this.$t("global.common.after_value", {
                        defaultValue: "更改后值",
                    }),
                    key: "afterValue",
                },
                {
                    title: this.$t("global.log.date", {
                        defaultValue: "操作时间",
                    }),
                    key: "createdAt",
                },
            ];
        },
    },
    methods: {
        //获取计划单详情
        getDetail() {
            if (this.type === "add") return;
            this.loading = true;
            HttpQueryAccountOne({ id: this.id })
                .then((res) => {
                    this.loading = false;
                    this.formData = res.data;
                    this.logList = res.data.updateLogEntityList;
                })
                .catch((err) => {
                    this.loading = false;
                    this.$VMessage.error(
                        this.$t(err.langCode, { defaultValue: err.message })
                    );
                });
        },

		//更新单据数据
		async save() {
			const valid = await this.$refs.formbase.validate();
			if (!valid) return;
            let flag = true;
            // label
            if (this.formData.accountType == 1) {
                if (this.formData.channelLabelAccount && this.formData.channelLabelPassword && this.formData.channelLabelShipperCode) {
                    flag = true;
                }
                else if (this.formData.labelAccount && this.formData.labelPassword && this.formData.labelShipperCode) {
                    flag = true;
                }
                else {
                    flag = false;
                }
            }
            console.log(flag);
            if (!flag) return this.$VMessage.warning('平台单和非平台单至少填写一组');
			this.loading = true;
            if (this.type == "add") {
                HttpCreateAccountOne(this.formData)
                    .then((res) => {
                        this.loading = false;
                        this.goback();
                    })
                    .catch((err) => {
                        this.loading = false;
                        this.$VMessage.error(err.message);
                    });
            } else {
                let {
                    accountType,
                    carrierAccount,
                    billingAccount,
                    labelAccount,
                    labelPassword,
                    labelShipperCode,
                    channelLabelAccount,
                    channelLabelPassword,
                    channelLabelShipperCode
                } = {
                    ...this.formData
                };
                let datajson = {
                    id: Number(this.id),
                    accountType,
                    carrierAccount,
                    billingAccount,
                    labelAccount,
                    labelPassword,
                    labelShipperCode,
                    channelLabelAccount,
                    channelLabelPassword,
                    channelLabelShipperCode
                };
                HttpSaveAccountOne(datajson)
                    .then((res) => {
                        this.loading = false;
                        this.goback();
                    })
                    .catch((err) => {
                        this.loading = false;
                        this.$VMessage.error(err.message);
                    });
            }
        },
        //确认
        async confirm() {
            await this.save(true);
            this.modalProps = {
                show: true,
                alert: "success",
                params: { id: this.id, ...this.formData },
                title: this.$t("global.datepicker.confirm", {
                    defaultValue: "确认",
                }),
                ajaxRequest: HttpConfirmWorkOrder,
                callback: this.goback,
                showDesc: false,
                formdata: [
                    {
                        label: this.$t("global.common.notes", {
                            defaultValue: "备注",
                        }),
                        tag: "vTextarea",
                        key: "reason",
                        span: 24,
                        labelWidth: 60,
                        required: false,
                    },
                ],
            };
        },
        //取消
        async cancel() {
            this.modalProps = {
                show: true,
                alert: "error",
                params: { id: this.id },
                title: this.$t("global.common.cancel", {
                    defaultValue: "取消",
                }),
                ajaxRequest: HttpCancelWorkOrder,
                callback: this.goback,
                showDesc: false,
                formdata: [
                    {
                        label: this.$t("global.common.notes", {
                            defaultValue: "备注",
                        }),
                        tag: "vTextarea",
                        key: "remark",
                        span: 24,
                        labelWidth: 60,
                        required: false,
                    },
                ],
            };
        },
        goback() {
            if (this.querytype) {
                this.$emit("on-close");
            } else {
                this.$router.push({
                    name: "basicdataCarrierAccount",
                });
            }
        },
    },
};
</script>
